import { render, staticRenderFns } from "./DigitalEmployee.vue?vue&type=template&id=0438791b&scoped=true&"
import script from "./DigitalEmployee.vue?vue&type=script&lang=js&"
export * from "./DigitalEmployee.vue?vue&type=script&lang=js&"
import style0 from "./DigitalEmployee.vue?vue&type=style&index=0&id=0438791b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0438791b",
  null
  
)

export default component.exports